import {languagesMenu, loginUrl} from '../../utils';
import {links, homeLink} from '../common';
import * as css from './mobile.scss';
import {radioInputName} from './mobileUtils';
import {defaultProfileImage} from '../../config';
import iconUser from '../svg/user';

const renderUser = ({profileImage, userName}, config, t) => {
  return `
    <img
      class="${css.profileImage}"
      src="${profileImage || defaultProfileImage(config)}"
      alt="${userName}"
      id="${css.profileImage}"
      data-hook="profile-image"
    >

    <div
      class="${css.profileFallBack}"
      data-hook="profile-fall-back"
    >
      &nbsp;
    </div>

    <span
      class="${css.profileRow}"
      data-hook="hello-text"
    >
        ${t('hello')},
    </span>

    <span
      class="${css.profileRow}"
      data-hook="user-name"
    >
        ${userName}
    </span>
  `;
};

const renderSignUpLink = (config, isMobile, t) => {
  return `
    <a
      data-bi="200"
      href="${loginUrl(config, isMobile)}"
      title="${t('title_signin')}"
      tabindex="${config.tabIndex[0]}"
      role="menuitem"
      data-hook="sign-up-link"
    >
      <i
        class="${css.icon} ${css.iconInlineUser}"
        title="${t('signup_form_submit')}"
        data-hook="sign-up-icon"
      >
        ${iconUser}
      </i>
      ${t('signup_form_submit')}
    </a>
  `;
};

const renderMenuLinks = (mainLinks, config) => {
  return links(
    mainLinks,
    {
      list: css.menu,
      item: css.menuItem,
      itemContent: `${css.menuContent} ${css.link}`,
    },
    null,
    config.tabIndex[0],
    {
      role: 'menu',
      id: `${css.menuOpen}-menu`,
    },
    null,
    {
      role: 'menuitem',
    },
  );
};

const renderLanguagesMenu = (config, location) => {
  return links(
    languagesMenu(config.supportedLanguages.filter(language => config.language !== language), location),
    {
      list: css.menu,
      item: css.menuItem,
      itemContent: css.menuContent,
    },
    null,
    config.tabIndex[0],
    {
      role: 'menu',
      id: `${css.languagesOpen}-menu`,
    },
    null,
    {
      role: 'menuitem',
      'data-hook': 'language-link',
    },
  );
};

export default ({mainLinks, t, config, user, location = null, isMobile}) => `
  <input aria-hidden="true" type="radio" name="${radioInputName}" class="${css.hidden}" id="${css.allClosed}" checked>
  <input aria-hidden="true" type="radio" name="${radioInputName}" class="${css.hidden}" id="${css.menuOpen}" data-bi="202">
  <input aria-hidden="true" type="radio" name="${radioInputName}" class="${css.hidden}" id="${css.languagesOpen}">

  <div class="${css.controls}" role="menubar">
    <a
      href="${homeLink(config.language)}"
      class="${css.logo} ${css.controlLeft}"
      title="${t('title_wix_logo')}"
      tabindex="${config.tabIndex[0]}"
      data-hook="header-wix-logo"
    >
      <img
        src="${config.baseUrl}assets/wixLogo.svg"
        class="${css.logoImg}" alt="Wix"
      >
    </a>

    <button
      class="${css.button} ${css.controlRight} ${css.visibleWhenMenuClosed}"
      data-switch-to="${css.menuOpen}"
      tabindex="${config.tabIndex[0]}"
      aria-label="${t('open_menu')}"
      id="${css.allClosed}-label"
      data-hook="open-menu"
    >
      <img
        src="${config.baseUrl}assets/menu.svg"
        alt="${t('open_menu')}"
      >
    </button>
  </div>

  <div class="${css.sections}" role="dialog" data-hook="menu-section" aria-modal="true" aria-hidden="true">
    <button
      class="${css.button} ${css.visibleWhenMenuOpen} ${css.controlRight}"
      data-switch-to="${css.allClosed}"
      tabindex="${config.tabIndex[0]}"
      aria-label="${t('close')}"
      id="${css.menuOpen}-label"
      data-hook="close-menu"
    >
      <img src="${config.baseUrl}assets/close.svg" alt="${t('close')}">
    </button>

    <section class="${css.section}" id="${css.menuOpen}-section" aria-hidden="true" data-hook="menu-section">
      <h2 class="${css.sectionHeader} ${css.divider}" tabindex="${config.tabIndex[0]}">
        ${user ? renderUser(user, config, t) : renderSignUpLink(config, isMobile, t)}
      </h2>

      ${renderMenuLinks(mainLinks, config)}
    </section>

    <section class="${css.section} ${css.level2}" id="${css.languagesOpen}-section" aria-hidden="true">
      <button
        class="${css.button} ${css.visibleWhenLanguagesOpen} ${css.controlLeft}"
        data-switch-to="${css.menuOpen}"
        tabindex="${config.tabIndex[0]}"
        aria-label="${t('back')}"
        id="${css.languagesOpen}-label"
        data-hook="back"
        >
        <img src="${config.baseUrl}assets/back.svg" alt="${t('back')}">
      </button>

      <h2 class="${css.sectionHeader} ${css.divider}" aria-hidden="true">
        <span class="${css.headline}">${t('choose_language')}</span>
      </h2>

      ${renderLanguagesMenu(config, location)}
    </section>
  </div>
`;
